import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { Box } from "../design-system";
import { colors } from "../design-system/colors";
import { userContext } from "../../stores/users/userContext";
import { PROFILE_TAB } from "./constants/accountText";
import EditProfileModal from "./EditProfileModal";
import ProfileCardHeader from "./components/ProfileCardHeader";
import Divider from "../design-system/Divider";
import ProfileFieldRow from "./components/ProfileFieldRow";

const CARD_BG = colors.card.profileBackground;

const ProfileTab = observer(() => {
  const userStore = useContext(userContext);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const fullName = userStore.getUserFullName() || "";
  const email = userStore.getUserEmail() || "";
  const isNameEmpty = !fullName;

  return (
    <>
      <Box
        sx={{
          backgroundColor: CARD_BG,
          borderRadius: "16px",
          padding: "32px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          width: "100%",
          minHeight: "400px",
        }}
      >
        <ProfileCardHeader onEditClick={() => setIsEditOpen(true)} />

        <Divider />

        <ProfileFieldRow
          label={PROFILE_TAB.USER_NAME_LABEL}
          value={isNameEmpty ? PROFILE_TAB.EMPTY_PLACEHOLDER : fullName}
        />
        <Divider />
        <ProfileFieldRow label={PROFILE_TAB.EMAIL_LABEL} value={email} />
      </Box>

      <EditProfileModal
        open={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        currentFullName={fullName}
      />
    </>
  );
});

export default ProfileTab;
